<template lang="pug">
OrderActionModal(v-if="show" :show="show" max-width="min(100vw - 2rem, 28rem)" @close="onClose")
  template(slot="header")
    span.replicate-modal__title.uppercase Replicar · {{ sourceProduct.product }}

  .replicate-modal
    .input-container.arrow
      select.select(v-model.number="count" autocomplete="ño" required)
        option(v-for="n in countOptions" :key="n" :value="n") {{ n }}
      label.label.show Cantidad

    template(v-if="count >= 1")
      .replicate-modal__colors
        .replicate-modal__colors-title Colores
        .replicate-modal__color-row(v-for="(_, index) in count" :key="index")
          .input-container.arrow.replicate-modal__color-select
            select.select(v-model="colors[index]" autocomplete="ño" required)
              option(value="")
              option(v-for="option in colorOptions" :key="option" :value="option") {{ capitalize(option) }}
            label.label.uppercase(:class="{ show: true }") {{ replicaReference(index) }}

      .replicate-modal__sync
        shCheckbox(v-model="syncVariants" label="Sincronizar variantes")

    shActionButton(
      :action="replicate"
      text="Replicar"
      textRunning="Replicando..."
      :normalColor="true"
      :disabled="!isValid"
    )
</template>

<script>
import gql from '@my/graphql'
import gqlProduct from '@/graphql/product'
import modals from '@my/store/modals'
import mFilters from '@/mixins/filters'
import OrderActionModal from '@/components/pages/order/refund/OrderActionModal.vue'
import shActionButton from '@/components/elements/ActionButton.vue'
import shCheckbox from '@/components/elements/Checkbox.vue'

export default {
  name: 'ReplicateProductModal',

  mixins: [mFilters],

  components: {
    OrderActionModal,
    shActionButton,
    shCheckbox
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    sourceProduct: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      count: 1,
      colors: [''],
      syncVariants: true,
      countOptions: Array.from({ length: 20 }, (_, i) => i + 1)
    }
  },

  computed: {
    colorOptions () {
      return this.$store.state.variables.colors || []
    },

    defaultColorName () {
      return (this.sourceProduct.colors && this.sourceProduct.colors[0]) || ''
    },

    baseReferenceNumber () {
      const product = this.sourceProduct.product || ''
      const parsed = parseInt(product.slice(2), 10)
      return Number.isFinite(parsed) ? parsed : null
    },

    referencePrefix () {
      return (this.sourceProduct.product || '').slice(0, 2)
    },

    isValid () {
      return this.count >= 1 &&
        this.count <= 20 &&
        this.colors.length === this.count &&
        this.colors.every(color => !!color)
    }
  },

  watch: {
    show (visible) {
      if (visible) this.resetForm()
    },

    count (newCount) {
      this.adjustColors(newCount)
    }
  },

  methods: {
    resetForm () {
      this.count = 1
      this.colors = [this.defaultColorName]
      this.syncVariants = true
    },

    replicaReference (index) {
      const number = this.baseReferenceNumber != null
        ? this.baseReferenceNumber + index + 1
        : index + 1
      return `${this.referencePrefix}${number}`
    },

    adjustColors (count) {
      while (this.colors.length < count) {
        this.colors.push(this.defaultColorName)
      }
      if (this.colors.length > count) {
        this.colors.splice(count)
      }
    },

    onClose () {
      this.$emit('close')
    },

    async replicate () {
      if (!this.isValid) {
        modals.showMessage({ message: 'Selecciona la cantidad y un color para cada réplica', type: 'error' })
        return true
      }

      const errors = []
      const response = await gql.mutate(gqlProduct.REPLICATE, {
        product: this.sourceProduct.product,
        count: this.count,
        colors: this.colors,
        syncVariants: this.syncVariants
      }, false, errors)

      if (errors.length) {
        modals.showMessage({ message: errors[0], type: 'error' })
        return true
      }

      if (response) {
        const created = response.data.replicateProduct || []
        const names = created.map(p => p.product).join(', ')
        modals.showMessage({ message: `Productos replicados: ${names}` })
        this.$emit('replicated', created)
        this.onClose()
      }

      return true
    }
  }
}
</script>

<style lang="stylus" scoped>
.replicate-modal
  padding 0 1.5rem 1.5rem
  display flex
  flex-direction column
  gap 1.5rem

.replicate-modal__title
  font-size 1rem
  font-weight 600

.replicate-modal__colors
  display flex
  flex-direction column
  gap .8rem

.replicate-modal__colors-title
  font-size 1rem
  font-weight 600

.replicate-modal__color-row
  width 100%

.replicate-modal__color-select
  width 100%
  margin 0

.replicate-modal__sync
  display flex
  align-items center
</style>



// WEBPACK FOOTER //
// src/components/pages/product/ReplicateProductModal.vue